import { createSlice } from "@reduxjs/toolkit";

let nextId = 1;
const initialState = [];

const toastSlice = createSlice({
  name: "toasts",
  initialState,
  reducers: {
    addToast: {
      reducer(state, action) {
        state.push(action.payload);
      },
      prepare({ message, isSuccess }) {
        return { payload: { id: nextId++, message, isSuccess } };
      },
    },
    removeToast(state, action) {
      return state.filter((toast) => toast.id !== action.payload);
    },
    clearToasts() {
      return [];
    },
  },
});

export const { addToast, removeToast, clearToasts } = toastSlice.actions;
export default toastSlice.reducer;
